import { denoAdapter } from "./runtime";
import { runPreview } from "./preview.impl";

await runPreview(denoAdapter);
